import Vue from "vue";
import Vuex from "vuex";
import pt_br from "./langs/pt_br";
import en from "./langs/en";
import es from "./langs/es";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    modules: {
      pt_br,
      en,
      es,
    },
})
